import React from "react";
import styled from "styled-components";
import ReportEthicsShow from "./ReportEthicsShow";

const Container = styled.div`
  color: #1e293b !important;
  padding: 16px;
  background: #ffffff;
  border-radius: 12px;
  /* box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.06); */
  border: none;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const HeaderSection = styled.div`
  margin-bottom: 12px;
`;

const TitleWrapper = styled.div`
  margin-bottom: 8px;
`;

const Title = styled.h2`
  margin: 0 0 6px 0;
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.2;
  letter-spacing: -0.025em;
`;

const SubtitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
  flex-wrap: wrap;
`;

const CategoryBadge = styled.span`
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  padding: 3px 8px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  /* box-shadow: 0 1px 2px rgba(59, 130, 246, 0.3); */
`;

const SizeInfo = styled.span`
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
  background: #f1f5f9;
  padding: 3px 6px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
`;

const Separator = styled.span`
  color: #cbd5e1;
  font-weight: 300;
`;

const CodeSection = styled.div`
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 6px 8px;
  margin-bottom: 12px;
`;

const Code = styled.p`
  margin: 0;
  letter-spacing: 0.5px;
  font-size: 10px;
  font-weight: 500;
  color: #64748b;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
`;

const AttributesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: auto;
`;

const AttributeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
`;

const AttributeTitle = styled.h3`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
`;

const DishDescription = ({ dish, t }) => {

  return (
    <Container>
      <HeaderSection>
        <TitleWrapper>
          <Title>
            {dish?.name || 'Unnamed Dish'}
          </Title>
          <SubtitleRow>
            {dish?.category?.name && (
              <CategoryBadge>
                {t(dish.category.name)}
              </CategoryBadge>
            )}
            {dish?.size && dish?.unit_abbr && (
              <>
                <Separator>•</Separator>
                <SizeInfo>
                  {dish.size} {dish.unit_abbr}
                </SizeInfo>
                <Separator>•</Separator>
                <SizeInfo>
                 ps: {dish.portion_size} {dish.unit_abbr}
                </SizeInfo>
              </>
            )}
          </SubtitleRow>
        </TitleWrapper>
        
        {dish?.gtin && (
          <CodeSection>
            <Code>
              GTIN: {dish.gtin}
            </Code>
          </CodeSection>
        )}
      </HeaderSection>

      <AttributesSection>
        <AttributeWrapper>
          <ReportEthicsShow 
            isAnimal={dish?.is_animal} 
            isAnimalKilled={dish?.is_animal_killed}
            isVegan={dish?.is_vegan} 
            isVegetarian={dish?.is_vegetarian} 
            ethicsUnknownConfirmed={dish?.ethics_unknown_confirmed}
            size="medium"
          />
          <AttributeTitle>{t("Etik")}</AttributeTitle>
        </AttributeWrapper>
      </AttributesSection>
    </Container>
  );
};

export default DishDescription;